import {
    guideClickOnElement,
    guideWaitForElement,
    guideClickOnElementInTopActivity,
    guideFillInput,
    guideWaitForElementLong,
    guideWaitForValue,
    clickOnGridRow,
    guideWaitForElementByXPath
} from "@/components/dashboard/guides/guidNavigation";
import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";


export function inquiryGuideSteps(initialMenu) {
    let menu = initialMenu;
    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through obtaining Project Specification for Suppliers. Let's get started.",
            imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Inquiry-2.png",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu="mobile-"
                }
                else {
                    menu=""
                }
            }
        },
        {
            target: () => `#${menu}m-plm`,
            previous: true,
            content: "Click on the PRODUCT LIFECYCLE module.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu="mobile-"
                    EventBus.$emit('openMainMenu');
                    await guideClickOnElement(`#${menu}m-plm`);
                } else {
                    menu=""
                    await guideClickOnElement('#m-plm');
                }
                await sleep(500);
            }
        },
        {
            target: () => `#${menu}plm-form-ProductInSeason`,
            previous: true,
            content: "Now, click on the Projects section.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu="mobile-"
                    await guideClickOnElement(`[id='${menu}plm-form-ProductInSeason'] a`)
                } else {
                    menu=""
                    await guideClickOnElement("[id='plm-form-ProductInSeason'] a")
                }
                await guideWaitForElementByXPath("//*[contains(@class, 'activity-top')]//*[@data-test-path='base-grid']//*[@data-row='0']//*[@data-col='0']")
                await sleep(500);
            }
        },
        {
            targetXPath: "//*[contains(@class, 'activity-top')]//*[@data-test-path='base-grid']//*[@data-row='0']//*[@data-col='0']",
            previous: true,
            content: "Let’s select the project.",
            beforeNext: async () => {
                await clickOnGridRow(0)
                await guideWaitForElement('.activity-top [data-test-path="grid-header-details-Products in Season"]');
                await sleep(500);
            }
        },
        {
            target: '.activity-top [data-test-path="grid-header-details-Products in Season"]',
            previous: true,
            content: "Now, click on the Details button.",
            beforeNext: async () => {
                await guideClickOnElement('.activity-top [data-test-path="grid-header-details-Products in Season"]');
                await guideWaitForElement('.activity-top [data-test-path="Inquiry_Printout"]');
                await sleep(500);
            }
        },
        {
            target: '.activity-top [data-test-path="Inquiry_Printout"]',
            previous: true,
            content: "After data preparation let's generate Project Specification.",
            beforeNext: async () => {
                await guideClickOnElement('.activity-top [data-test-path="Inquiry_Printout"]');
                await guideWaitForElement('#bv-modal-select-language .modal-footer button[data-test-path="save-button"]');
                await sleep(500);
            }
        },
        // {
        //     target: '#bv-modal-select-language .modal-footer button[data-test-path="save-button"]',
        //     header: {
        //         title: 'Sixth Step',
        //     },
        //     previous: true,
        //     content: "After language selection let's generate printout.",
        //     beforeNext: async () => {
        //         await guideClickOnElement('#bv-modal-select-language .modal-footer button[data-test-path="save-button"]');
        //         await guideWaitForElement('[data-test-path="notifications_bottom"]');
        //         await sleep(500);
        //     }
        // },
        {
            target: '[data-test-path="notifications_bottom"]',
            content: "Now after generation you can download, check and send your automated prepared Project Specification.",
        },
    ]
}